import { Component, Input, OnInit } from '@angular/core';
import { Orientation } from '../../../constants/orientation.constants';

/**
 * When placed immediately after an element containing the `lsqHasTooltip` directive, displays a tooltip when the `lsqHasTooltip` element is hovered over.
 *
 * @see LsqHasTooltipDirective
 * @export
 * @class LsqTooltipComponent
 * @implements {OnInit}
 *
 * @property {string} for The `id` of the `lsq-tooltip` instance's previous sibling, which should contain the `lsqHasTooltip` directive.
 * @property {string} id Sets the `id` of the container div. Should be equal to the value passed to `lsqHasTooltip` on the instance's previous sibling.
 * @property {'center'|'left'|'right'} [align] Sets the text-align of the tooltip.
 * @property {string} [containerClass] Adds a `class` to the container div.
 * @property {'top'|'bottom'} [orientation] Defines where the tooltip should appear relative to the `lsqHasTooltip` element.
 *
 * @example
 * <strong id="my-tooltip-button" lsqHasTooltip="my-tooltip">Hover me</strong>
 * <lsq-tooltip for="my-tooltip-button" [id]="'my-tooltip'" orientation="bottom">Tooltip!</lsq-tooltip>
 */

@Component({
    selector: 'lsq-tooltip',
    template: `
        <div
            [id]="id"
            class="lsq-tooltip-main"
            [ngClass]="[orientation, containerClass]"
            [ngStyle]="{ 'margin-left': marginLeft }"
        >
            <span class="tooltip-triangle"></span>
            <div class="lsq-tooltip-content">
                <p [ngStyle]="{ 'text-align': align }">
                    <ng-content></ng-content>
                </p>
            </div>
        </div>
    `
})
export class LsqTooltipComponent implements OnInit {
    @Input() public for: string;
    @Input() public id: string;
    @Input() public align?: 'center' | 'left' | 'right' = 'center';
    @Input() public containerClass? = '';
    @Input() public orientation?: 'top' | 'bottom' = Orientation.Top;

    public marginLeft: string;

    public ngOnInit() {
        const smRemWidth = 8;
        const lgRemWidth = 20;
        const isLg: boolean = this.containerClass.match(/(\s|^)lg(\s|$)/) != null;
        const btn = document.getElementById(this.for);
        const html = document.getElementsByTagName('html')[0];
        const htmlPixelFontSize = +window
            .getComputedStyle(html, null)
            .getPropertyValue('font-size')
            .replace('px', '');

        btn.style.setProperty('display', 'inline-block');

        // Wait for the DOM elements to render
        setTimeout(() => {
            const btnPixelWidth = btn.offsetWidth;
            const btnRemWidth = btnPixelWidth / htmlPixelFontSize;
            const offset = btnRemWidth / 2 + (isLg ? lgRemWidth / 2 : smRemWidth / 2);

            this.marginLeft = '-' + offset + 'rem';
        });
    }
}
